<script lang="ts">
    import {onMount} from "svelte";
    import LabelValueView from "../common/Value/LabelValueView.svelte";
    import {BinaryTable} from "../../lib/Table/BinaryTable";

    export let binary;

    onMount(() => {
    });


</script>

<span class="binary-status-area-view">

    <LabelValueView label="バイナリ状況" value={BinaryTable.Status.map[binary.status]}
                    hoverValueTipsMessage={binary.error_message}
    />
    <LabelValueView label="コンバート状況" value={BinaryTable.ConvertStatus.map[binary.convert_status]}
                    hoverValueTipsMessage={binary.convert_error_message}
    />
    <LabelValueView label="分析状況" value={BinaryTable.AnalysisStatus.map[binary.analysis_status]}
                    hoverTipsMessage="分析が終わるとアイコンやバージョンなどが表示されます"
                    hoverValueTipsMessage={binary.analysis_error_message}
    />


</span>
<style lang="scss">
    .binary-status-area-view {

        .status {

        }

    }
</style>